const isDev = process.env.NODE_ENV !== 'production';

const CMS_GATE_URL = isDev
  ? 'http://www.cmsgateuat.marathon.mesos.sportmaster.ru'
  : 'http://www.cms-gate.web.local';

const GEO_GATE_URL = isDev
 ? 'http://rest-app.geogate-uat.k8s-dev.gksm.local'
 : 'http://rest-app.geogate-ostfun.k8s-prod.gksm.local';

module.exports = {
  CMS_GATE_URL,
  GEO_GATE_URL,
};
